import {
  Avatar,
  Button,
  Card,
  Grid,
  IconButton,
  Select,
  MenuItem,
  Stack,
  Typography,
  Dialog,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/system';
import React, { useState, useEffect } from 'react';
import { fontsize16, poppins400 } from 'theme/common.style';
import { poppins600 } from 'theme/common.style';
import { poppins700 } from 'theme/common.style';
import { fontsize20 } from 'theme/common.style';
import { poppins500 } from 'theme/common.style';
import { fontsize14, poppins300 } from 'theme/common.style';
import FormControl from '@mui/material/FormControl';
import House from 'assets/images/House.png';
import { Style } from '@mui/icons-material';
import Search from 'assets/svg/Search.svg';
import FHB from 'assets/icons/fhb.svg';
import Line from 'assets/svg/Line.svg';
import { GETBUYERMATCH } from 'constant/app.config';
import { getApiCall } from 'api/apiService';
import CircularProgress from '@mui/material/CircularProgress';
import {
  displayFlex,
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import Dp from 'assets/dummy/buy.jpg';
import PlaceholderImage from 'assets/svg/Placeholder.svg';

export const BuyerCard2Buyermatch = ({
  onClose,
  propertyBuyer,
  buyerId,
  selectedProperty,
  popover,
  ownercardpropaction,
  fromInsight,
}) => {
  const propertyId = selectedProperty?.property?.propertyId;
  const ExpIcon = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7626 6.80661C14.7626 9.18634 12.8546 11.0945 10.4732 11.0945C8.0926 11.0945 6.18374 9.18634 6.18374 6.80661C6.18374 4.42688 8.0926 2.51953 10.4732 2.51953C12.8546 2.51953 14.7626 4.42688 14.7626 6.80661ZM10.4732 18.7245C6.95865 18.7245 3.99121 18.1533 3.99121 15.9494C3.99121 13.7447 6.97729 13.1937 10.4732 13.1937C13.9886 13.1937 16.9552 13.7649 16.9552 15.9689C16.9552 18.1736 13.9691 18.7245 10.4732 18.7245Z"
          fill="#F74646"
        />
      </svg>
    );
  };
  function CircularProgressWithProfile(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={45}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={45}
        />
        <Box
          sx={{
            top: '50%',
            left: '53%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            <Avatar
              alt="Remy"
              src={Dp}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          </Typography>
        </Box>
      </Box>
    );
  }

  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={(props.value / 10) * 100}
          sx={{ color: '#10D35E' }}
          thickness={5}
          size={45}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.rating}
          </Typography>
        </Box>
      </Box>
    );
  }
  const [buyerMatching, setBuyerMatching] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getApiCall(
          GETBUYERMATCH + `/${buyerId}/${propertyId}`
        );
        setBuyerMatching(response?.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [buyerId]);

  const datas = buyerMatching;
  const ExpandIcon = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.1"
          x="0.863281"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
        />
        <path
          d="M17.6924 7.19042L23.1825 7.19042L23.1825 12.6949"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.8633 7.5L17.6133 12.75"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M14.0381 21.8106L8.54795 21.8106L8.54795 16.3061"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.1133 16.2559L8.86328 21.5059"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  };
  const RightArrow = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.1"
          x="0.863281"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
        />
        <path
          d="M14.1133 8.375L20.2061 14.4678L14.1133 20.5605"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const BedIcon = () => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_12294_29983)">
          <path
            d="M2.10938 8.89211H14.6197C15.1354 8.89211 15.5533 8.47413 15.5533 7.95851C15.5533 7.44288 15.1354 7.0249 14.6197 7.0249H2.10938C1.59376 7.0249 1.17578 7.44288 1.17578 7.95851C1.17575 8.47413 1.59376 8.89211 2.10938 8.89211Z"
            fill="#6C2AD2"
          />
          <path
            d="M9.29884 5.01123C9.02635 5.01123 8.80469 5.23289 8.80469 5.50538V6.14602H12.6291V5.50538C12.6291 5.23289 12.4074 5.01123 12.1349 5.01123H9.29884Z"
            fill="#6C2AD2"
          />
          <path
            d="M3.21938 5.50547C3.21938 4.74835 3.83531 4.13241 4.59243 4.13241H7.42852C7.78881 4.13241 8.11693 4.2721 8.36212 4.49991C8.6073 4.2721 8.93543 4.13241 9.29572 4.13241H12.1318C12.8889 4.13241 13.5049 4.74835 13.5049 5.50547V6.1461H14.9313V3.11915C14.9313 2.60353 14.5133 2.18555 13.9977 2.18555H2.72657C2.21095 2.18555 1.79297 2.60353 1.79297 3.11915V6.1461H3.21938V5.50547Z"
            fill="#6C2AD2"
          />
          <path
            d="M4.59181 5.01123C4.31932 5.01123 4.09766 5.23289 4.09766 5.50538V6.14602H7.92204V5.50538C7.92204 5.23289 7.70038 5.01123 7.42789 5.01123H4.59181Z"
            fill="#6C2AD2"
          />
          <path
            d="M0.863281 9.77124V13.8147H1.74219V12.2123H14.9844V13.8147H15.8633V9.77124H0.863281Z"
            fill="#6C2AD2"
          />
        </g>
        <defs>
          <clipPath id="clip0_12294_29983">
            <rect
              width="15"
              height="15"
              fill="white"
              transform="translate(0.863281 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const ShowerIcon = () => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_12294_29992)">
          <path
            d="M13.4883 0.5C13.0741 0.5 12.7383 0.835781 12.7383 1.25V1.5H7.23828C6.54828 1.50081 5.98909 2.06 5.98828 2.75V4H5.48828C5.07406 4 4.73828 4.33578 4.73828 4.75V5.61125C3.64931 6.28247 2.98678 7.47078 2.98828 8.75V9.046C2.68969 9.15156 2.48959 9.43331 2.48828 9.75V10.25C2.48828 10.3881 2.60022 10.5 2.73828 10.5H10.7383C10.8763 10.5 10.9883 10.3881 10.9883 10.25V9.75C10.987 9.43331 10.7869 9.15156 10.4883 9.046V8.75C10.4897 7.7545 10.0938 6.79959 9.38828 6.09725C9.19222 5.90819 8.97394 5.74356 8.73828 5.607V4.75C8.73828 4.33578 8.4025 4 7.98828 4H7.48828V3.25C7.48828 3.11194 7.60022 3 7.73828 3H12.7383V3.5C12.7383 3.91422 13.0741 4.25 13.4883 4.25H14.2383V0.5H13.4883ZM10.4883 9.75V10H2.98828V9.75C2.98828 9.61194 3.10022 9.5 3.23828 9.5H10.2383C10.3763 9.5 10.4883 9.61194 10.4883 9.75ZM9.03603 6.4515C9.64697 7.06022 9.98972 7.88756 9.98828 8.75V9H3.48828V8.75C3.48747 7.62038 4.08391 6.5745 5.05653 6H8.42178C8.64541 6.12297 8.85194 6.27475 9.03603 6.4515ZM7.98828 4.5C8.12634 4.5 8.23828 4.61194 8.23828 4.75V5.5H5.23828V4.75C5.23828 4.61194 5.35022 4.5 5.48828 4.5H7.98828ZM12.7383 2.5H7.73828C7.32406 2.5 6.98828 2.83578 6.98828 3.25V4H6.48828V2.75C6.48828 2.33578 6.82406 2 7.23828 2H12.7383V2.5ZM13.7383 3.75H13.4883C13.3502 3.75 13.2383 3.63806 13.2383 3.5V1.25C13.2383 1.11194 13.3502 1 13.4883 1H13.7383V3.75Z"
            fill="#6C2AD2"
          />
          <path
            d="M6.73828 11C6.60022 11 6.48828 11.1119 6.48828 11.25V12.25C6.48828 12.3881 6.60022 12.5 6.73828 12.5C6.87634 12.5 6.98828 12.3881 6.98828 12.25V11.25C6.98828 11.1119 6.87634 11 6.73828 11Z"
            fill="#6C2AD2"
          />
          <path
            d="M6.73828 13C6.60022 13 6.48828 13.1119 6.48828 13.25V14.25C6.48828 14.3881 6.60022 14.5 6.73828 14.5C6.87634 14.5 6.98828 14.3881 6.98828 14.25V13.25C6.98828 13.1119 6.87634 13 6.73828 13Z"
            fill="#6C2AD2"
          />
          <path
            d="M9.73828 12C9.60022 12 9.48828 12.1119 9.48828 12.25V13.25C9.48828 13.3881 9.60022 13.5 9.73828 13.5C9.87634 13.5 9.98828 13.3881 9.98828 13.25V12.25C9.98828 12.1119 9.87634 12 9.73828 12Z"
            fill="#6C2AD2"
          />
          <path
            d="M7.73828 12C7.60022 12 7.48828 12.1119 7.48828 12.25V13.25C7.48828 13.3881 7.60022 13.5 7.73828 13.5C7.87634 13.5 7.98828 13.3881 7.98828 13.25V12.25C7.98828 12.1119 7.87634 12 7.73828 12Z"
            fill="#6C2AD2"
          />
          <path
            d="M5.73828 12C5.60022 12 5.48828 12.1119 5.48828 12.25V13.25C5.48828 13.3881 5.60022 13.5 5.73828 13.5C5.87634 13.5 5.98828 13.3881 5.98828 13.25V12.25C5.98828 12.1119 5.87634 12 5.73828 12Z"
            fill="#6C2AD2"
          />
          <path
            d="M3.73828 12C3.60022 12 3.48828 12.1119 3.48828 12.25V13.25C3.48828 13.3881 3.60022 13.5 3.73828 13.5C3.87634 13.5 3.98828 13.3881 3.98828 13.25V12.25C3.98828 12.1119 3.87634 12 3.73828 12Z"
            fill="#6C2AD2"
          />
          <path
            d="M4.73828 11C4.60022 11 4.48828 11.1119 4.48828 11.25V12.25C4.48828 12.3881 4.60022 12.5 4.73828 12.5C4.87634 12.5 4.98828 12.3881 4.98828 12.25V11.25C4.98828 11.1119 4.87634 11 4.73828 11Z"
            fill="#6C2AD2"
          />
          <path
            d="M8.73828 11C8.60022 11 8.48828 11.1119 8.48828 11.25V12.25C8.48828 12.3881 8.60022 12.5 8.73828 12.5C8.87634 12.5 8.98828 12.3881 8.98828 12.25V11.25C8.98828 11.1119 8.87634 11 8.73828 11Z"
            fill="#6C2AD2"
          />
          <path
            d="M8.73828 13C8.60022 13 8.48828 13.1119 8.48828 13.25V14.25C8.48828 14.3881 8.60022 14.5 8.73828 14.5C8.87634 14.5 8.98828 14.3881 8.98828 14.25V13.25C8.98828 13.1119 8.87634 13 8.73828 13Z"
            fill="#6C2AD2"
          />
          <path
            d="M4.73828 13C4.60022 13 4.48828 13.1119 4.48828 13.25V14.25C4.48828 14.3881 4.60022 14.5 4.73828 14.5C4.87634 14.5 4.98828 14.3881 4.98828 14.25V13.25C4.98828 13.1119 4.87634 13 4.73828 13Z"
            fill="#6C2AD2"
          />
          <path
            d="M5.73828 14C5.60022 14 5.48828 14.1119 5.48828 14.25V15.25C5.48828 15.3881 5.60022 15.5 5.73828 15.5C5.87634 15.5 5.98828 15.3881 5.98828 15.25V14.25C5.98828 14.1119 5.87634 14 5.73828 14Z"
            fill="#6C2AD2"
          />
          <path
            d="M7.73828 14C7.60022 14 7.48828 14.1119 7.48828 14.25V15.25C7.48828 15.3881 7.60022 15.5 7.73828 15.5C7.87634 15.5 7.98828 15.3881 7.98828 15.25V14.25C7.98828 14.1119 7.87634 14 7.73828 14Z"
            fill="#6C2AD2"
          />
        </g>
        <defs>
          <clipPath id="clip0_12294_29992">
            <rect
              width="15"
              height="15"
              fill="white"
              transform="translate(0.863281 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const CarIcon = () => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_12294_30034)">
          <path
            d="M11.5005 6.99815C11.4523 6.99815 11.4027 7.00509 11.3532 7.01868L10.7933 7.17291L10.212 5.7567C10.0473 5.3555 9.56046 5.02905 9.12679 5.02905H3.68596C3.25224 5.02905 2.76545 5.3555 2.60077 5.7567L2.02019 7.17093L1.46725 7.01863C1.41777 7.00503 1.36823 6.9981 1.31996 6.9981C1.05532 6.9981 0.863281 7.20026 0.863281 7.47872V7.80874C0.863281 8.13382 1.12781 8.39835 1.45288 8.39835H1.51624L1.42239 8.62693C1.26938 8.99956 1.14482 9.63066 1.14482 10.0337V12.8471C1.14482 13.1722 1.40935 13.4367 1.73442 13.4367H2.50445C2.82952 13.4367 3.09405 13.1722 3.09405 12.8471V12.1446H9.71864V12.8471C9.71864 13.1722 9.98317 13.4367 10.3082 13.4367H11.0782C11.4032 13.4367 11.6678 13.1722 11.6678 12.8471V10.0337C11.6678 9.63077 11.5432 8.99967 11.3902 8.62699L11.2963 8.3984H11.3676C11.6926 8.3984 11.9572 8.13387 11.9572 7.8088V7.47877C11.9572 7.20032 11.7651 6.99815 11.5005 6.99815ZM2.44285 8.07817L3.3223 5.93608C3.42083 5.6961 3.71365 5.49971 3.97306 5.49971H8.83969C9.0991 5.49971 9.39192 5.69604 9.49044 5.93608L10.3699 8.07817C10.4684 8.31815 10.3368 8.51454 10.0773 8.51454H2.73545C2.47599 8.51448 2.34439 8.31815 2.44285 8.07817ZM4.40601 10.7877C4.40601 10.9174 4.29984 11.0235 4.17021 11.0235H2.4996C2.36987 11.0235 2.26375 10.9174 2.26375 10.7877V9.98596C2.26375 9.85628 2.36987 9.75016 2.4996 9.75016H4.17021C4.29984 9.75016 4.40601 9.85628 4.40601 9.98596V10.7877ZM10.5331 10.7877C10.5331 10.9174 10.427 11.0235 10.2973 11.0235H8.62674C8.49711 11.0235 8.39094 10.9174 8.39094 10.7877V9.98596C8.39094 9.85628 8.49711 9.75016 8.62674 9.75016H10.2973C10.427 9.75016 10.5331 9.85628 10.5331 9.98596V10.7877Z"
            fill="#6C2AD2"
          />
          <path
            d="M15.1276 2.56323H12.3351C11.9285 2.56323 11.5977 2.89409 11.5977 3.30067V6.09325C11.5977 6.49989 11.9285 6.83074 12.3351 6.83074H13.4561V13.0984C13.4561 13.2504 13.5793 13.3736 13.7313 13.3736C13.8834 13.3736 14.0065 13.2504 14.0065 13.0984V6.8308H15.1276C15.5343 6.8308 15.8651 6.49995 15.8651 6.0933V3.30073C15.8651 2.89409 15.5343 2.56323 15.1276 2.56323ZM14.4951 4.87865C14.3345 5.02324 14.098 5.09656 13.792 5.09656H13.3877C13.3391 5.09656 13.2996 5.13613 13.2996 5.18468V5.86659C13.2996 5.94067 13.2393 6.00089 13.1652 6.00089H12.859C12.7848 6.00089 12.7246 5.94062 12.7246 5.86659V3.52761C12.7246 3.45347 12.7849 3.3932 12.859 3.3932H13.6304C14.1415 3.3932 14.3323 3.4702 14.489 3.60324C14.6544 3.74354 14.7381 3.95842 14.7381 4.24204C14.7381 4.51918 14.6564 4.73329 14.4951 4.87865Z"
            fill="#6C2AD2"
          />
          <path
            d="M14.0586 3.95803C13.984 3.90167 13.8519 3.87305 13.6662 3.87305H13.3888C13.3403 3.87305 13.3008 3.91257 13.3008 3.96106V4.52149C13.3008 4.56998 13.3403 4.6095 13.3888 4.6095H13.555C13.6161 4.6095 13.7147 4.60498 13.7749 4.59943C13.8333 4.59409 13.9981 4.5702 14.0586 4.52451C14.1312 4.46958 14.168 4.37458 14.168 4.24221C14.168 4.10857 14.1312 4.01296 14.0586 3.95803Z"
            fill="#6C2AD2"
          />
        </g>
        <defs>
          <clipPath id="clip0_12294_30034">
            <rect
              width="15"
              height="15"
              fill="white"
              transform="translate(0.863281 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const [expand, setExpand] = useState(false);
  const [open, setOpen] = useState(false);

  const [action, setAction] = useState('');

  const handleChange = (e) => {
    setAction(e.target.value);
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches1250 = useMediaQuery(theme.breakpoints.down(1250));
  const matches870 = useMediaQuery(theme.breakpoints.down(870));

  return (
    <>
      <Grid
        container
        sx={{
          padding: matchessm ? '10px' : popover ? '20px' : '0px 10px',
        }}
      >
        <Grid item sx={{ marginTop: '7px' }}>
          <Stack
            sx={{ width: matchessm ? '93%' : '325px', height: '30px' }}
            style={{
              justifyContent: 'flex-end',
              display: 'flex',
              flexDirection: 'row',
              position: !ownercardpropaction && 'absolute',
              top: 28,
              alignItems: 'center',
              backgroundColor: 'white',
            }}
          >
            <Grid onClick={onClose} sx={{ p: '6px', marginTop: '3px' }}>
              <RightArrow />{' '}
            </Grid>
          </Stack>
        </Grid>
        <Grid
          item
          sx={{
            marginTop:
              popover && matches870 ? '60px' : popover ? '20px' : '15px',
            width: matchessm ? '100%' : 'auto',
          }}
        >
          <Grid sx={{ width: matchessm ? '100%' : 'auto' }}>
            <Grid container sx={{ width: matchessm ? '100%' : 'auto' }}>
              <Grid
                item={expand ? 3 : 12}
                sx={{ width: matchessm ? '100%' : 'auto' }}
              >
                <Stack
                  sx={{ width: matchessm ? '100%' : '325px', height: '112px' }}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    container
                    sx={{
                      paddingTop: '13px',
                      width: matchessm ? '100%' : 'auto',
                    }}
                  >
                    <Stack
                      sx={{
                        borderRadius: '10px',
                        background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
                      }}
                      style={{
                        width: matchessm ? '100%' : '325px',
                        height: '67px',
                      }}
                      alignItems={'center'}
                      paddingTop={'21px'}
                    >
                      <Avatar
                        alt="Search"
                        src={Search}
                        style={{
                          width: '91px',
                          height: '91px',
                          alignItems: 'center',
                          position: 'relative',
                        }}
                      />
                    </Stack>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
            <Grid
              container
              paddingTop={'13px'}
              sx={{ width: matchessm ? '100%' : 'auto' }}
            >
              <Grid item sx={{ width: matchessm ? '100%' : 'auto' }}>
                <Stack
                  sx={{ width: matchessm ? '100%' : '325px', height: '30px' }}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Grid item>
                    <Stack
                      sx={{
                        width: matchessm ? '100%' : '156px',
                        height: '30px',
                      }}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography
                        sx={{ ...poppins600, fontSize: '20px' }}
                        style={{ color: '#000000' }}
                      >
                        Buyer Match
                      </Typography>
                    </Stack>
                  </Grid>
                </Stack>
              </Grid>
            </Grid>

            <Grid
              container
              sx={{ alignItems: 'center', width: matchessm ? '100%' : 'auto' }}
            >
              {!propertyBuyer ? (
                <Stack
                  sx={{
                    alignItems: 'center',
                    border: '1px solid #E7E5E5',
                    borderRadius: '10px',
                    marginTop: '10px',
                    width: matchessm ? '100%' : '327px',
                    height: '283px',
                    justifyContent: 'center',
                  }}
                >
                  <Stack
                    sx={{
                      width: '298px',
                      height: '38px',
                      background: '#F7F8F7',
                    }}
                    alignItems={'center'}
                    justifyContent={'center'}
                  >
                    <Typography
                      sx={{
                        textAlign: 'center',
                        ...poppins500,
                        ...fontsize14,
                        color: '#26344E',
                      }}
                      alignItems={'center'}
                      justifyContent={'center'}
                    >
                      Property
                    </Typography>
                  </Stack>
                  <Box
                    sx={{
                      padding: '10px',
                      marginTop: '10px',
                      minHeight: '205px',
                      width: '298px',
                      display: 'flex',
                      flexDirection: 'row',
                      background: '#FFFFFF',
                      boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                      borderRadius: '6px',
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Stack spacing={2}>
                          {selectedProperty?.propertyMedia[2]?.propertyMedia ? (
                            <img
                              src={
                                selectedProperty?.propertyMedia[2]
                                  ?.propertyMedia
                              }
                              alt="Image"
                              height={'125px'}
                              width={'133px'}
                              style={{ borderRadius: '6px' }}
                            />
                          ) : (
                            <img
                              src={PlaceholderImage}
                              alt="Five cats looking around a field."
                              height={'125px'}
                              width={'133px'}
                              style={{ borderRadius: '6px' }}
                            />
                          )}
                          <Button
                            variant="text"
                            sx={{
                              border: '1px solid #9A9A9F',
                              ...poppins400,
                              fontSize: '12px',
                              color: '#9A9A9F',
                              borderRadius: '5px',
                              textTransform: 'capitalize',
                              height: '30px',
                            }}
                          >
                            {selectedProperty?.property?.status}
                          </Button>
                        </Stack>
                      </Grid>

                      <Grid item xs={6}>
                        <Stack
                          direction={'column'}
                          sx={{
                            minHeight: '173px',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Stack direction={'row'} spacing={2}>
                            <Stack
                              direction={'row'}
                              spacing={1}
                              alignItems={'center'}
                            >
                              <BedIcon />
                              <Typography
                                sx={{
                                  fontWeight: '400px',
                                  fontSize: '12px',
                                  fontFamily: 'Poppins',
                                  color: '#000000',
                                }}
                              >
                                {
                                  selectedProperty?.propertyOtherDetails
                                    ?.bedRoomCount
                                }
                              </Typography>
                            </Stack>
                            <Stack
                              direction={'row'}
                              spacing={1}
                              alignItems={'center'}
                            >
                              <ShowerIcon />
                              <Typography
                                sx={{
                                  fontWeight: '400px',
                                  fontSize: '12px',
                                  fontFamily: 'Poppins',
                                  color: '#000000',
                                }}
                              >
                                {
                                  selectedProperty?.propertyOtherDetails
                                    ?.bathRoomCount
                                }
                              </Typography>
                            </Stack>
                            <Stack
                              direction={'row'}
                              spacing={1}
                              alignItems={'center'}
                            >
                              <CarIcon />
                              <Typography
                                sx={{
                                  fontWeight: '400px',
                                  fontSize: '12px',
                                  fontFamily: 'Poppins',
                                  color: '#000000',
                                }}
                              >
                                {
                                  selectedProperty?.propertyOtherDetails
                                    ?.otherCarParking
                                }
                              </Typography>
                            </Stack>
                          </Stack>
                          <Typography
                            sx={{
                              fontSize: '10px',
                              fontWeight: ' 400px',
                              fontFamily: 'Poppins',
                              color: '#666666',
                            }}
                          >
                            {selectedProperty?.propertyAddress?.streetName}
                          </Typography>
                          {selectedProperty?.property?.status === 'Sold' && (
                            <Stack>
                              <Typography
                                sx={{
                                  fontSize: '10px',
                                  fontWeight: ' 400px',
                                  fontFamily: 'Poppins',
                                  color: '#666666',
                                }}
                              >
                                Last Sold :
                                <Typography
                                  sx={{
                                    fontSize: '10px',
                                    fontFamily: 'Poppins',
                                    color: '#000000',
                                    fontWeight: 500,
                                  }}
                                >
                                  12/01/2001
                                </Typography>
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '10px',
                                  fontWeight: ' 400px',
                                  fontFamily: 'Poppins',
                                  color: '#666666',
                                }}
                              >
                                Price :
                                <Typography
                                  sx={{
                                    fontSize: '10px',
                                    fontFamily: 'Poppins',
                                    color: '#000000',
                                    fontWeight: 500,
                                  }}
                                >
                                  $1250,000
                                </Typography>
                              </Typography>
                            </Stack>
                          )}

                          <Select
                            sx={{
                              ...poppins500,
                              fontSize: '12px',
                              fontColor: '#112347',
                              border: '1px solid #6C2AD2',
                              width: '130px',
                              height: '30px',
                              borderRadius: '6px',
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                            }}
                            value={action}
                            label="Action"
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                            <MenuItem value={''}>Action</MenuItem>
                            <MenuItem value={20}>Buyer Match</MenuItem>
                          </Select>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                </Stack>
              ) : null}
            </Grid>

            <Grid
              container
              sx={{
                paddingTop: '13px',
                width: matchessm ? '100%' : 'auto',
              }}
            >
              <Grid
                item
                sx={{
                  width: matchessm ? '100%' : '326px',
                  border: '1px solid #E7E5E5',
                  borderRadius: '8px',
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '20px 15px',
                }}
              >
                <Stack
                  sx={{
                    width: '297px',
                    height: '38px',
                    backgroundColor: '#F7F8F7',
                    borderRadius: '6px',
                    gap: '135px',
                  }}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    padding: '10px',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    sx={{ ...poppins500, fontSize: '14px', color: '#26344E' }}
                  >
                    Known Buyers
                  </Typography>
                  <Typography
                    sx={{ ...poppins300, fontSize: '12px', color: '#26344E' }}
                  >
                    Total{' '}
                    {
                      Object.keys(datas?.userDetails || {}).filter(
                        (key) =>
                          !isNaN(key) &&
                          datas?.userDetails[key]?.isKnownBuyer === 1
                      ).length
                    }
                  </Typography>
                </Stack>

                {Object.entries(datas?.userDetails || {})
                  .filter(([key]) => !isNaN(key))
                  .map(([key, item], index) => {
                    return (
                      item?.isKnownBuyer !== 0 && (
                        <Stack
                          style={{
                            display: 'flex',
                            padding: '10px',
                            alignItems: 'center',
                          }}
                          key={index}
                        >
                          <Stack
                            sx={{
                              width: '279px',
                              maxHeight: ' 119.99px',
                              justifyContent: 'space-between',
                              gap: '69px',
                            }}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <Stack
                              container
                              sx={{ width: '123px', maxHeight: '119.99px' }}
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '11px',
                              }}
                            >
                              <Stack
                                sx={{ width: '121.37px', maxHeight: '54.99px' }}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  gap: '9px',
                                  padding: '0px',
                                }}
                              >
                                <Typography sx={userDetCont}>
                                  <Typography sx={imageCont}>
                                    <Typography
                                      sx={displayFlex}
                                      style={{
                                        justifyContent: 'center',
                                        position: 'relative',
                                        alignItems: 'center',
                                        paddingRight: '10px',
                                      }}
                                    >
                                      <CircularProgressWithProfile
                                        value={item?.profileActivity}
                                      />
                                    </Typography>
                                  </Typography>
                                </Typography>

                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontWeight: '400px',
                                    fontSize: '12px',
                                    color: '#112347',
                                  }}
                                  style={{
                                    maxHeight: '18px',
                                    width: '57px',
                                    lineHeight: '18px',
                                    paddingLeft: '9px',
                                  }}
                                >
                                  KeilGlass
                                </Typography>
                              </Stack>

                              <Stack
                                sx={{ width: '123px', maxHeight: '54px' }}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-start',
                                  gap: item?.exp === '' ? '0px' : '15px',
                                  padding: '0px',
                                }}
                              >
                                <Stack
                                  sx={{ width: '116px', maxHeight: '21px' }}
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: item?.profile === '' ? '0px' : '46px',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      ...poppins400,
                                      fontSize: '14px',
                                      color: '#112347',
                                    }}
                                  >
                                    {item?.profile}
                                  </Typography>
                                  {item?.exp != '' && (
                                    <Stack
                                      sx={{
                                        width: '40.57px',
                                        height: '19.45px',
                                      }}
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '2px',
                                      }}
                                    >
                                      <Typography
                                        display="flex"
                                        alignItems="center"
                                        textAlign="center"
                                      >
                                        <ExpIcon />
                                        <Typography
                                          style={{
                                            width: '19.13px',
                                            height: '19.13px',
                                            backgroundColor: '#F64646',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#FFFFFF',
                                            fontFamily: 'Poppins',
                                            fontSize: '12.92px',
                                          }}
                                        >
                                          {item?.exp}
                                        </Typography>
                                      </Typography>
                                    </Stack>
                                  )}
                                </Stack>

                                <Stack
                                  sx={{ width: '123px', maxHeight: '18px' }}
                                >
                                  <Typography
                                    sx={{
                                      ...poppins400,
                                      fontSize: '12px',
                                      color: '#112347',
                                    }}
                                  >
                                    Last Offer:
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Stack>

                            <Box sx={{}}>
                              <Typography
                                sx={displayFlex}
                                style={{
                                  justifyContent: 'center',
                                  position: 'relative',
                                  alignItems: 'center',
                                }}
                              >
                                <CircularProgressWithLabel
                                  value={item?.interestedAvg}
                                  rating={item?.rating}
                                />
                                <CircularProgress
                                  value={100}
                                  variant="determinate"
                                  sx={{
                                    position: 'absolute',
                                    color: '#C4C4C461',
                                    ...poppins500,
                                    fontSize: '14px',
                                  }}
                                  thickness={5}
                                  size={45}
                                />
                              </Typography>
                            </Box>
                          </Stack>

                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                              alignItems: 'flex-start',
                              padding: '0',
                              gap: '19px',
                              width: '290px',
                              height: '59px',
                              marginTop: '20px',
                              marginBottom: '20px',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '8px',
                                width: '45%',
                                height: '100%',
                                background: 'rgba(108, 42, 210, 0.1)',
                              }}
                            >
                              <Typography
                                sx={{
                                  ...poppins700,
                                  fontSize: '16px',
                                  color: '#6C2AD2',
                                }}
                              >
                                92 Days
                              </Typography>
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Active
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                height: '100%',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '8px',
                                width: '45%',
                                backgroundColor: 'rgba(47, 205, 255, 0.12)',
                              }}
                            >
                              <Typography
                                sx={{
                                  ...poppins700,
                                  fontSize: '16px',
                                  color: ' #2FCDFF',
                                }}
                              >
                                {item?.previouslyOfferMade}
                              </Typography>
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Offer previously Made
                              </Typography>
                            </Box>
                          </Box>

                          <img src={Line} alt="Line" />
                        </Stack>
                      )
                    );
                  })}

                {Object.values(datas?.userDetails || {}).every(
                  (user) => user.isKnownBuyer !== 1
                ) && (
                  <Typography
                    sx={{
                      ...poppins300,
                      fontSize: '12px',
                      color: '#26344E',
                      mt: '20px',
                    }}
                  >
                    Known Buyers not available
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Grid
              container
              sx={{
                paddingTop: '13px',
                width: matchessm ? '100%' : 'auto',
              }}
            >
              <Grid
                item
                sx={{
                  width: matchessm ? '100%' : '326px',
                  border: '1px solid #E7E5E5',
                  borderRadius: '8px',
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '20px 15px',
                }}
              >
                <Stack
                  sx={{
                    width: '297px',
                    height: '38px',
                    backgroundColor: '#F7F8F7',
                    borderRadius: '6px',
                    justifyContent: 'space-between',
                  }}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    padding: '10px',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    sx={{ ...poppins500, fontSize: '14px', color: '#26344E' }}
                  >
                    Unknown Buyers
                  </Typography>
                  <Typography
                    sx={{ ...poppins300, fontSize: '12px', color: '#26344E' }}
                  >
                    Total{' '}
                    {
                      Object.keys(datas?.userDetails || {}).filter(
                        (key) =>
                          !isNaN(key) &&
                          datas?.userDetails[key]?.isKnownBuyer === 0
                      ).length
                    }
                  </Typography>
                </Stack>

                {Object.entries(datas?.userDetails || {})
                  .filter(([key]) => !isNaN(key))
                  .map(([key, item], index) => {
                    return (
                      item?.isKnownBuyer != 1 && (
                        <Stack
                          style={{
                            display: 'flex',
                            padding: '10px',
                            alignItems: 'center',
                            width: matchessm ? '100%' : 'auto',
                          }}
                          key={index}
                        >
                          <Stack
                            sx={{
                              width: '279px',
                              maxHeight: ' 119.99px',
                              justifyContent: 'space-between',
                              gap: '69px',
                            }}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <Stack
                              container
                              sx={{ width: '123px', maxHeight: '119.99px' }}
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '11px',
                              }}
                            >
                              <Stack
                                sx={{ width: '121.37px', maxHeight: '54.99px' }}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  gap: '9px',
                                  padding: '0px',
                                }}
                              >
                                <Typography sx={userDetCont}>
                                  <Typography sx={imageCont}>
                                    <Typography
                                      sx={displayFlex}
                                      style={{
                                        justifyContent: 'center',
                                        position: 'relative',
                                        alignItems: 'center',
                                        paddingRight: '10px',
                                      }}
                                    >
                                      <CircularProgressWithProfile
                                        value={item?.profileActivity}
                                      />
                                    </Typography>
                                  </Typography>
                                </Typography>

                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontWeight: '400px',
                                    fontSize: '12px',
                                    color: '#112347',
                                  }}
                                  style={{
                                    maxHeight: '18px',
                                    width: '57px',
                                    lineHeight: '18px',
                                    paddingLeft: '9px',
                                  }}
                                >
                                  KeilGlass
                                </Typography>
                              </Stack>

                              <Stack
                                sx={{ width: '123px', maxHeight: '54px' }}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-start',
                                  gap: item?.exp === '' ? '0px' : '15px',
                                  padding: '0px',
                                }}
                              >
                                <Stack
                                  sx={{ width: '116px', maxHeight: '21px' }}
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: item?.profile === '' ? '0px' : '46px',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      ...poppins400,
                                      fontSize: '14px',
                                      color: '#112347',
                                    }}
                                  >
                                    {item?.profile}
                                  </Typography>
                                  {item?.exp != '' && (
                                    <Stack
                                      sx={{
                                        width: '40.57px',
                                        height: '19.45px',
                                      }}
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '2px',
                                      }}
                                    >
                                      <Typography
                                        display="flex"
                                        alignItems="center"
                                        textAlign="center"
                                      >
                                        <ExpIcon />
                                        <Typography
                                          style={{
                                            width: '19.13px',
                                            height: '19.13px',
                                            backgroundColor: '#F64646',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#FFFFFF',
                                            fontFamily: 'Poppins',
                                            fontSize: '12.92px',
                                          }}
                                        >
                                          {item?.exp}
                                        </Typography>
                                      </Typography>
                                    </Stack>
                                  )}
                                </Stack>

                                <Stack
                                  sx={{ width: '123px', maxHeight: '18px' }}
                                >
                                  <Typography
                                    sx={{
                                      ...poppins400,
                                      fontSize: '12px',
                                      color: '#112347',
                                    }}
                                  >
                                    Last Offer:
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Stack>

                            <Box sx={{}}>
                              <Typography
                                sx={displayFlex}
                                style={{
                                  justifyContent: 'center',
                                  position: 'relative',
                                  alignItems: 'center',
                                }}
                              >
                                <CircularProgressWithLabel
                                  value={item?.interestedAvg}
                                  rating={item?.rating}
                                />
                                <CircularProgress
                                  value={100}
                                  variant="determinate"
                                  sx={{
                                    position: 'absolute',
                                    color: '#C4C4C461',
                                    ...poppins500,
                                    fontSize: '14px',
                                  }}
                                  thickness={5}
                                  size={45}
                                />
                              </Typography>
                            </Box>
                          </Stack>

                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                              alignItems: 'flex-start',
                              padding: '0',
                              gap: '19px',
                              width: '290px',
                              height: '59px',
                              marginTop: '20px',
                              marginBottom: '20px',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '8px',
                                width: '45%',
                                height: '100%',
                                background: 'rgba(108, 42, 210, 0.1)',
                              }}
                            >
                              <Typography
                                sx={{
                                  ...poppins700,
                                  fontSize: '16px',
                                  color: '#6C2AD2',
                                }}
                              >
                                92 Days
                              </Typography>
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Active
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                height: '100%',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '8px',
                                width: '45%',
                                backgroundColor: 'rgba(47, 205, 255, 0.12)',
                              }}
                            >
                              <Typography
                                sx={{
                                  ...poppins700,
                                  fontSize: '16px',
                                  color: ' #2FCDFF',
                                }}
                              >
                                {item?.previouslyOfferMade}
                              </Typography>
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Offer previously Made
                              </Typography>
                            </Box>
                          </Box>

                          <img src={Line} alt="Line" />
                        </Stack>
                      )
                    );
                  })}
                {Object.values(datas?.userDetails || {}).every(
                  (user) => user.isKnownBuyer !== 0
                ) && (
                  <Typography
                    sx={{
                      ...poppins300,
                      fontSize: '12px',
                      color: '#26344E',
                      mt: '20px',
                    }}
                  >
                    Unknown Buyers not available
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
